var map = {
	"./afghanistan-logo-icon.png": 52022,
	"./australia-logo-icon.png": 71486,
	"./bangladesh-logo-icon.png": 76757,
	"./durban's-super-giants-logo-icon.png": 90319,
	"./england-logo-icon.png": 37467,
	"./india-logo-icon.png": 54365,
	"./ireland-logo-icon.png": 39997,
	"./joburg-super-kings-logo-icon.png": 91592,
	"./mi-cape-town-logo-icon.png": 56437,
	"./netherlands-logo-icon.png": 93592,
	"./new-zealand-logo-icon.png": 19630,
	"./paarl-royals-logo-icon.png": 95731,
	"./pakistan-logo-icon.png": 52571,
	"./pretoria-capitals-logo-icon.png": 15614,
	"./south-africa-logo-icon.png": 54668,
	"./sri-lanka-logo-icon.png": 83230,
	"./sunrisers-eastern-cape-logo-icon.png": 43923,
	"./zimbabwe-logo-icon.png": 99357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60281;